import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToCurrentContext,
  type CurrentContext,
  type CurrentContextApiResource,
} from './currentContextApi.types';

export async function fetchCurrentContext(): Promise<CurrentContext> {
  const response = await httpClient.get<CurrentContextApiResource>('/me/context');
  return mapApiResourceToCurrentContext(response.data);
}
